module.exports = __webpack_public_path__ + "static/media/BOLTON_APP_LOGO_TEXT.6e325461.png";